import * as BrowserActions from '../actionTypes/browser';

export function hasFocus(value) {
    return {
        type: BrowserActions.SET_HAS_FOCUS,
        hasFocus: value,
    };
}

export function setCurrentLocation(location) {
    return {
        type: BrowserActions.SET_CURRENT_LOCATION,
        location,
    };
}
